import React from "react";
import authLogo from "../../../assets/logo/authLogo.png";

const AuthLogo = () => {
  return (
    <div className="d-flex justify-content-center mb-3">
      <img 
        src={authLogo} 
        alt="Auth page logo" 
        style={{ maxWidth: "150px", height: "auto" }}
      />
    </div>
  );
};

export default AuthLogo;
